import {triggerEvent} from "../modules/browser-util";
const MAIN = "main";
const SUB = "sub";
const CAL = "cal";
const CLOSE_MAIN_SELECTOR = ".forcia-state-search.ipt_icon_closeWT";
const CLOSE_SUB_SELECTOR = (sub) => (`.forcia-layer-sub[data-layer="${sub}"] .ipt_icon_close`);
const CLOSE_CAL_SELECTOR = "#forcia-course-calendar .ipt_icon_close";

const hash = {
	openMain: function() {
		location.hash = MAIN;
	},
	closeMain: function() {
		if (location.hash.slice(1) ===  MAIN) { // remove "#"
			history.back();
		}
	},
	openSub: function() {
		location.hash = SUB;
	},
	closeSub: function() {
		if (location.hash.slice(1) === SUB) {
			history.back();
		}
	},
	openCourseCal: function() {
		location.hash = CAL;
	},
	closeCourseCal: function() {
		if (location.hash.slice(1) === CAL) {
			history.back();
		}
	}
};

function generateHashChangeHandler(state) {
	return function hashChangeHandler(ev) {
		const oldHash = ev.oldURL.split("#")[1];
		const newHash = ev.newURL.split("#")[1];
		if (oldHash === MAIN && newHash !==  SUB) { // sublayerを開くとき
			const closeButton = document.querySelector(CLOSE_MAIN_SELECTOR);
			triggerEvent(closeButton, "click");
		} else if (oldHash === SUB && newHash === MAIN) { // sublayerを閉じるとき
			const subLayer = state.subLayer;
			const closeButton = document.querySelector(CLOSE_SUB_SELECTOR(subLayer));
			triggerEvent(closeButton, "click");
		} else if (oldHash === CAL) { // コース別カレンダーを閉じるとき
			const closeButton = document.querySelector(CLOSE_CAL_SELECTOR);
			triggerEvent(closeButton, "click");
		}
	};
}

export {
	hash,
	generateHashChangeHandler
};



// WEBPACK FOOTER //
// ./web/WEB-INF/js/client/search/hash-control.js